import PropTypes from 'prop-types';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { LeaseDealsModel, LeaseDealsPaths } from 'client/data/models/lease-deals';

const LeaseDealsHiddenGemsLinkUI = props => {
  const { bestDeal, children } = props;

  const monthlyPayment = bestDeal?.payment;
  const paymentMedian = bestDeal?.paymentMedian;

  if (!(monthlyPayment && paymentMedian)) {
    return null;
  }

  return children({ monthlyPayment, paymentMedian });
};

LeaseDealsHiddenGemsLinkUI.propTypes = {
  bestDeal: PropTypes.shape({
    payment: PropTypes.number,
    paymentMedian: PropTypes.number,
  }),
  children: PropTypes.func.isRequired,
};

LeaseDealsHiddenGemsLinkUI.defaultProps = {
  bestDeal: undefined,
};

export const LeaseDealsHiddenGemsLink = connectToModel(LeaseDealsHiddenGemsLinkUI, {
  bestDeal: bindToPath(
    ({ make, model, year }) => LeaseDealsPaths.getFirstBestPaymentDealMMYPath({ make, model, year }),
    LeaseDealsModel,
    null,
    false
  ),
});

LeaseDealsHiddenGemsLink.propTypes = {
  make: PropTypes.string.isRequired,
  model: PropTypes.string.isRequired,
  year: PropTypes.string.isRequired,
};
